
export default {
  secteurs: [],
  secteursWithInterventions: []
}
